import * as actions from './actions';
import sendGoogleAnalyticsEvent from '../../utils/tracking/googleAnalytics';
import * as googleAnalyticsEvents from '../../utils/tracking/googleAnalytics';
import { getActionCompletedTime } from '../../utils/actionTiming';

const eventMappings = {};
eventMappings[actions.VOLUNTEER_COMPLETED] = [trackCompleteAction];

export default function trackVolunteer(type, state) {
    const eventTrackers = eventMappings[type];
    if (eventTrackers != null) {
        eventTrackers.map(f => f(state));
    }
}

function trackCompleteAction(state) {
    sendGoogleAnalyticsEvent(googleAnalyticsEvents.EVENT_ACTION_COMPLETED, {
        ...state.widget,
        action: state.widget.activeAction,
        actionCompleteTime: getActionCompletedTime(state, 'volunteer')
    });
}
